import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, BooleanDecoder, EnumDecoder, IntegerDecoder, StringDecoder, field } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { PermissionRoleForResponsibility } from './PermissionRole.js';
import { ResourcePermissions } from './ResourcePermissions.js';
import { PermissionLevel } from './PermissionLevel.js';
import { PermissionsResourceType } from './PermissionsResourceType.js';
export class MemberResponsibility extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.name = '';
        this.description = '';
        this.minimumMembers = null;
        this.maximumMembers = null;
        /**
         * Whether this is a national responsibility or not
         */
        this.organizationBased = true;
        /**
         * Limit this responsibility to specific organizations
         */
        this.organizationTagIds = null;
        /**
         * Whether this responsibility should be assigned to a specific group (or more) of a specific organization
         */
        this.defaultAgeGroupIds = null;
        /**
         * Automatically grant the following permissions
         */
        this.permissions = null;
        /**
         * Automatically grant limited permissions to the group associated with this responsibility
         */
        this.groupPermissionLevel = PermissionLevel.None;
    }
    get isGroupBased() {
        return this.defaultAgeGroupIds !== null;
    }
    compress() {
        var _a;
        (_a = this.permissions) === null || _a === void 0 ? void 0 : _a.compress();
    }
    createDefaultPermissions(group) {
        var _a;
        return PermissionRoleForResponsibility.create({
            name: this.name + (group ? ` van ${group.settings.name.toString()}` : ''),
            responsibilityId: this.id,
            responsibilityGroupId: (_a = group === null || group === void 0 ? void 0 : group.id) !== null && _a !== void 0 ? _a : null,
        });
    }
    getPermissions(groupId) {
        var _a, _b;
        const r = (_b = (_a = this.permissions) === null || _a === void 0 ? void 0 : _a.clone()) !== null && _b !== void 0 ? _b : PermissionRoleForResponsibility.create({
            id: this.id,
            name: this.name,
            level: PermissionLevel.None,
            responsibilityId: this.id,
            responsibilityGroupId: groupId,
            resources: new Map(),
        });
        r.name = this.name;
        r.id = this.id + (groupId ? '-' + groupId : '');
        r.responsibilityId = this.id;
        r.responsibilityGroupId = groupId;
        if (groupId && this.groupPermissionLevel !== PermissionLevel.None) {
            const map = new Map();
            map.set(groupId, ResourcePermissions.create({ level: this.groupPermissionLevel }));
            r.resources.set(PermissionsResourceType.Groups, map);
        }
        return r;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], MemberResponsibility.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], MemberResponsibility.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder })
], MemberResponsibility.prototype, "description", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], MemberResponsibility.prototype, "minimumMembers", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], MemberResponsibility.prototype, "maximumMembers", void 0);
__decorate([
    field({ decoder: BooleanDecoder, optional: true })
], MemberResponsibility.prototype, "organizationBased", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder), nullable: true, version: 273 })
], MemberResponsibility.prototype, "organizationTagIds", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder), nullable: true, version: 273 })
], MemberResponsibility.prototype, "defaultAgeGroupIds", void 0);
__decorate([
    field({ decoder: PermissionRoleForResponsibility, nullable: true, version: 279 })
], MemberResponsibility.prototype, "permissions", void 0);
__decorate([
    field({ decoder: new EnumDecoder(PermissionLevel), version: 279 })
], MemberResponsibility.prototype, "groupPermissionLevel", void 0);
export class PlatformResponsibility extends MemberResponsibility {
}
//# sourceMappingURL=MemberResponsibility.js.map